import SiteDataTable from './SiteDataTable';
import SiteDataTableContainer from './SiteDataTableContainer';

export default SiteDataTableContainer;
export { SiteDataTable };
